export default "__VITE_ASSET__gQEtdI3u__"